module.exports = __webpack_public_path__ + "img/cn.7a40cd85.png";